import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './ReportPayrollInfoScreen';
import ReportPayrollInfo from './ReportPayrollInfoScreen';
import { StoreState } from 'src/store/reducers';
import { getReportPayroll } from 'src/store/actions/reportPayroll-actions';

function mapStateToProps(state: StoreState): StateProps {
    return {
        reportPayroll: state.reportPayrolls.current,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: (id) => dispatch(getReportPayroll(id)),
    };
}

const ReportPayrollInfoScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(ReportPayrollInfo);

export default ReportPayrollInfoScreen;
